import { render } from "./Vault2.vue?vue&type=template&id=4063bf68&scoped=true&ts=true"
import script from "./Vault2.vue?vue&type=script&lang=ts"
export * from "./Vault2.vue?vue&type=script&lang=ts"

import "./Vault2.vue?vue&type=style&index=0&id=4063bf68&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4063bf68"]])

export default __exports__